/** Цены по сделке — ровно то, что отдаёт `GET /api/deals/{id}/price`. */
import { apiFetch } from "@/lib/api";

/** Период правки — самый тревожный из подходящих (спека `2026-09-25-deal-price-design.md`). */
export type PricePeriod = "after" | "issue" | "eve" | "repeat" | "contract" | "between";

export type PriceChange = {
  at: string;
  who: string | null;
  user_id: number | null;
  old: number;
  new: number;
  delta: number;
  /** Итог снижения: цена через 10 мин после правки минус прежняя (частичный возврат учтён). */
  net: number;
  type: string | null;
  period: PricePeriod;
  days_before: number | null;
  /** `issue_basis:plan|fact|both`, `mid_issue`, `on_add`, `restored`, `below_min:<тип>`. */
  notes: string[];
  alert: "high" | "low" | null;
};

export type PriceProduct = {
  id: number;
  contract_id: number;
  serial: number | null;
  name: string | null;
  image: string | null;
  is_sale: boolean;
  deleted: boolean;
  service: boolean;
  first: number;
  current: number;
  added: { at: string | null; who: string | null; price: number; type: string | null };
  changes: PriceChange[];
};

export type PriceAnchor = {
  at: string;
  kind: "contract" | "repeat" | "rent_start" | "rent_end" | "issue" | "return";
  title: string;
  text: string | null;
  who: string | null;
};

export type DealPrice = {
  deal_id: number;
  contract: {
    id: number;
    location: string | null;
    created: string | null;
    rent_start: string | null;
    rent_end: string | null;
    fact_start: string | null;
    fact_end: string | null;
  } | null;
  total: {
    first: number;
    current: number;
    down: number;
    up: number;
    down_by_period: Partial<Record<PricePeriod, number>>;
    alerts: { high: number; low: number };
  };
  anchors: PriceAnchor[];
  products: PriceProduct[];
};

export function loadDealPrice(id: number): Promise<DealPrice> {
  return apiFetch<DealPrice>(`/api/deals/${id}/price`);
}
